import { Field, HTMLLink, LayoutServiceData, Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { useRouter } from 'next/router';

import { getPageNameFromUrl, PageName } from 'lib/utils';
import Scripts from 'src/Scripts';
import getConfig from 'temp/config';

import { FormStateProvider } from './contexts/FormState/FormStateContext';
import { MetaTags } from './MetaTags';

const config = getConfig();
// Prefix public assets with a public URL to enable compatibility with Sitecore editors.
// If you're not supporting Sitecore editors, you can remove this.
const publicUrl = config.publicUrl;

interface LayoutProps {
  layoutData: LayoutServiceData;
  headLinks: HTMLLink[];
}

export interface RouteFields {
  [key: string]: unknown;

  PageTitle: Field;
  NoFollow: Field;
  NoIndex: Field;
}

const getBrandFromPageName = (pageName: PageName): string | undefined => {
  switch (pageName) {
    case PageName.GnSupportForms:
      return 'gn';
    case PageName.BlueParrottForms:
      return 'blueparrott';
    case PageName.SupportForms:
    case PageName.StoreForms:
    case PageName.TieredServicePortalForms:
    case PageName.StoreFormsAnyRoute:
      return undefined;
    default: {
      pageName satisfies never;
      return undefined;
    }
  }
};

const Layout = ({ layoutData, headLinks }: LayoutProps): React.JSX.Element => {
  const { route } = layoutData.sitecore;
  const router = useRouter();

  const fields = route?.fields as RouteFields;
  const pageName = getPageNameFromUrl(router.asPath);
  const brand = getBrandFromPageName(pageName);

  return (
    <>
      <Scripts />
      <MetaTags fields={fields} headLinks={headLinks} publicUrl={publicUrl} />

      {/* root placeholder for the app, which we add components to using route data */}
      <FormStateProvider>
        <div {...(brand && { 'data-brand': brand })}>
          {route && <Placeholder name="jss-main" rendering={route} />}
        </div>
      </FormStateProvider>
    </>
  );
};

export default Layout;
